import axios from "axios";
import qs from "qs";

export default {
  getFileName(file) {
    var fileName = "iotm/Zips";
    if (file.type.indexOf("video") != -1) fileName = "Videos";
    else if (file.type.indexOf("audio") != -1) fileName = "Audios";
    let index = file.name.lastIndexOf(".");
    let ext = file.name.substr(index + 1).toLowerCase();
    var dt = this.getDate().replace("-", "/").replace("-", "/");
    return fileName + "/" + dt + "/" + "oss_" + this.getGuid() + "." + ext;
  },
  getImgFileName(file) {
    var fileName = "zlwx/Image";

    let index = file.name.lastIndexOf(".");
    let ext = file.name.substr(index + 1).toLowerCase();
    var dt = this.getDate().replace("-", "/").replace("-", "/");
    return fileName + "/" + dt + "/" + "oss_" + this.getGuid() + "." + ext;
  },
  getGuid() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (
      S4() +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      "-" +
      S4() +
      S4() +
      S4()
    );
  },
  getDate() {
    let dt = new Date();
    let yy = dt.getFullYear();
    let mm = dt.getMonth() + 1;
    if (mm < 10) mm = "0" + mm;
    let dd = dt.getDate();
    if (dd < 10) dd = "0" + dd;
    return yy + "-" + mm + "-" + dd;
  },
  downLoad(url) {
    var downloadElement = document.createElement("a");
    downloadElement.style.display = "none";
    downloadElement.href = url;
    document.body.appendChild(downloadElement);
    downloadElement.click();
  },
  getFileName1(file) {
    var fileName = "Images";
    if (file.type.indexOf("image") != -1) fileName = "Images";
    else if (file.type.indexOf("audio") != -1) fileName = "Audios";
    else if (file.type.indexOf("video") != -1) fileName = "Videos";
    let index = file.name.lastIndexOf(".");
    let ext = file.name.substr(index + 1).toLowerCase();
    var dt = this.getDate().replace("-", "/").replace("-", "/");
    return fileName + "/" + dt + "/" + "oss_" + this.getGuid() + "." + ext;
  },

  getInt(v) {
    console.log(v);
    if (v && v != "") {
      return v;
    }
    return 0;
  },

  UploadFile(tp, file) {
    return new Promise((resolve, reject) => {
      let formData = new FormData();
      console.log("file", file);
      formData.append("file", file.raw);
      formData.append("name", file.name);

      axios
        .post("api/AliOss/UploadFile?tp=" + tp, formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => {
          let data = res.data;
          if (data.resultType == 0) {
            //自己的操作
            resolve(data);
            console.log(data.appendData, "314");
          } else {
            reject(data.message);
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getNewProblem() {
    return 5000;
  },
  getExport(url, data) {
    return new Promise((resolve, reject) => {
      //   axios.post(url, data).then((res) => {
      //     if (res.status == 200) {
      //       resolve(res);
      //     } else {
      //       this.$message.warning("没有数据可以导出");
      //       //   reject();
      //     }
      //   });
      axios
        .request({
          url: url,
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: qs.stringify(data),
          responseType: "blob",
        })
        .then((res) => {
          resolve(res);
        });
    });
  },
};



// WEBPACK FOOTER //
// ./src/assets/js/common.js